module.exports = __webpack_public_path__ + "static/img/mgy-bg.2989cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/mgy-bg.png
// module id = x/Nj
// module chunks = 96